require('./bootstrap');
require('slick-carousel');
require('./choose-category');
require('./dashboard');
require('./course-detail');
require('./account-menu');
const Swal = window.Swal = require('sweetalert2');
const moment = window.moment = require('moment');
const _ = window._ = require('lodash');
const axios = window.axios = require('axios').default;
require('./common');
